import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HtmlParseService } from '@commons/html-parser/html-parse.service';
import { secureExternalLinks } from '@core/utils/utils';
import { Company } from '@models/company/company';

@Component({
  selector: 'company-presentation',
  templateUrl: './presentation.component.html',
  styleUrls: ['./presentation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PresentationComponent implements OnInit {
  @Input() company: Company;

  tabContent: SafeHtml;
  secureExternalLinks = secureExternalLinks;

  constructor(private readonly htmlParser: HtmlParseService, private readonly domSanitizer: DomSanitizer) {}

  ngOnInit(): void {
    this.tabContent = this.domSanitizer.bypassSecurityTrustHtml(
      this.htmlParser.parse(this.company.presentationTab.description)
    );
  }
}
